import theme from '../../../themes/colors';

// add theme.cofeeNeutral1 as fallback color
const getGroupCardColor = (id: string) => {
  if (!id || typeof id !== 'string' || id.trim() === '')
    return theme.cofeeNeutral1;

  const bgColorList = [
    theme.cofeeBlue50,
    theme.cofeeOrange50,
    theme.cofeePurple50,
    theme.cofeeGreen1,
    theme.cofeeRed1,
    theme.cofeeYellow1,
    theme.cofeeViolet50
  ];

  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash * 31 + id.charCodeAt(i)) % 2_147_483_647;
  }

  const index = Math.abs(hash) % bgColorList.length;
  return bgColorList[index];
};

export default getGroupCardColor;
